/* eslint-disable */
import StoreService from '@/services/StoreService.js'

export const namespaced = true // ensures all mutations, actions and getters are namespaced under event.

export const state = {
    markers: []
}

export const mutations = {
    PUSH (state, data) {
        data.map(element => {
            let storeGeocode = JSON.parse(element.geocode)
            state.markers.push(
                {
                    visible: true,
                    id: element.nid,
                    title: element.title,
                    calenderid: element.timifyid,
                    address: element.address,
                    zip: element.zip,
                    city: element.city,
                    path: element.path,
                    phone: element.phone,
                    federalstate: element.federal_state,
                    openinghours: JSON.parse(element.opening_hours),
                    lunchbreak: element.lunch_break,
                    specialbushours: element.special_bushours,
                    status : element.status,
                    active: false,
                    distance: {
                        value: 0,
                        text: ''
                    },
                    position: {
                        lat: Number(storeGeocode.lat),
                        lng: Number(storeGeocode.lng)
                    }
                }
            )
        })
    },
    SET_ACTIVE (state, data) {
        for (var i = 0; i < state.markers.length; i++) {
            if (state.markers[i].id === data.id) {
                state.markers[i].active = true
            } else {
                state.markers[i].active = false
            }
        }
    },
    SET_DISTANCE (state, data) {
        let centerLoc = new data.google.maps.LatLng(data.center)
        state.markers.forEach(marker => {
            if (data.place || data.place.geometry) {
                let targetLoc = new data.google.maps.LatLng(marker.position)
                let distance = data.google.maps.geometry.spherical.computeDistanceBetween(centerLoc, targetLoc)
                marker.distance.value = distance
                if (data.radius !== 500) {
                    marker.distance.text = (distance / 1000).toFixed(2) + ' km'
                }
            } else {
                marker.distance.value = 0
                marker.distance.text = ''
            }
        })
    },
    SET_VISIBLITY (state, data) {
        if (data.place && data.place.geometry) {
            var convertedRadius = getters.convertedRadius(data.radius)
            state.markers.forEach(marker => {
                if (marker.distance.value < convertedRadius) {
                    marker.visible = true
                } else {
                    marker.visible = false
                }
            })
        } else {
            state.markers.forEach(marker => {
                marker.visible = true
            })
        }
    },
    SORT_BY_DISTANCE (state, data) {
        state.markers = state.markers.sort((a, b) => a.distance.value - b.distance.value)
    },
    SET_MARKERS (state, data) {
        state.markers = data
    },
    PUSH_WITH_DISTANCE (state, data) {
        let centerLoc = new data.google.maps.LatLng({
            lat: Number(data.position.lat),
            lng: Number(data.position.lng)
        })

        data.stores.map(element => {
            let storeGeocode = JSON.parse(element.geocode)
            let geocode = {
                lat: Number(storeGeocode.lat),
                lng: Number(storeGeocode.lng)
            }
            let targetLoc = new data.google.maps.LatLng(geocode)
            let distance = data.google.maps.geometry.spherical.computeDistanceBetween(centerLoc, targetLoc)
            let distanceObj = {
                value: distance,
                text: (distance / 1000).toFixed(2) + ' km'
            }
            state.markers.push(
                {
                    visible: true,
                    id: element.nid,
                    title: element.title,
                    calenderid: element.timifyid,
                    address: element.address,
                    zip: element.zip,
                    city: element.city,
                    path: element.path,
                    phone: element.phone,
                    federalstate: element.federal_state,
                    openinghours: element.opening_hours,
                    lunchbreak: element.lunch_break,
                    status : element.status,
                    specialbushours: element.special_bushours,
                    distance: distanceObj,
                    position: geocode
                }
            )
        })
    }
}

export const actions = {
    fetch ({ commit, dispatch }) {
        StoreService.getStores() // call getStore() in StoreService
            .then(response => {
                //  console.log(response.data);
                let data = response.data.data ? response.data.data : response.data
                commit('PUSH', data) // commit mutation, with payload
            }).finally(() => {
                dispatch('stopLoading', null,
                {
                    root: true
                }
               )
            })
            .catch(error => {
                console.log(error)
                const notification = {
                    type: 'error',
                    message: Drupal.t('Error getting stores informations.'),
                    sending: {
                        type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                        source: '/stores-json',
                        referer: window.location.href,
                        error: error.message,
                    }
                }
                dispatch('notification/add', notification,
                    {
                        root: true
                    }
                )
                dispatch('errorLoading', null,
                    {
                        root: true
                    }
                )
            })
    },
    fetchByCalenderId ({dispatch}, {calenderid, timifyid}) {
        StoreService.getStoreByCalenderId(calenderid, timifyid)
            .then(response => {
                if (response.data.length > 0) {
                    let element = response.data[0]
                    let storeGeocode = JSON.parse(element.geocode)
                    let store =
                    {
                        id: element.nid,
                        title: element.title,
                        calenderid: element.timifyid,
                        address: element.address,
                        zip: element.zip,
                        city: element.city,
                        path: element.path,
                        phone: element.phone,
                        federalstate: element.federal_state,
                        openinghours: element.opening_hours,
                        lunchbreak: element.lunch_break,
                        specialbushours: element.special_bushours,
                        email : element.email,
                        distance: {
                            value: 0,
                            text: ''
                        },
                        geolocation: {
                            lat: Number(storeGeocode.lat),
                            lng: Number(storeGeocode.lng)
                        }
                    }
                    dispatch('setStore', {source: 'list', store: store}, {root: true})
                } else {
                    dispatch('setStore', {source: 'list', store: -1 }, {root: true})
                }
            }).finally(() => {

            })
            .catch(error => {
                const notification = {
                    type: 'error',
                    message: Drupal.t('Error getting stores by id.'),
                    sending: {
                        type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                        source: '/stores-json',
                        referer: window.location.href,
                        error: error.message,
                    }
                }
                dispatch('notification/add', notification,
                    {
                        root: true
                    }
                )
                dispatch('errorLoading', null,
                    {
                        root: true
                    }
                )
            })
    },
    update ({ commit, dispatch, state }, {google, radius, place, center, live}) {
        commit('SET_DISTANCE', {google, center, place, radius})
        commit('SET_VISIBLITY', {place, radius})
        commit('SORT_BY_DISTANCE', {})
        let nearDistance = getters.nearDistance(state)
        if (!live) {
            dispatch('map/updateZoom', nearDistance, { root: true })
        }
        setTimeout(() => {
            dispatch('stopLoading', null, { root: true })
        }, 100)
    },
    setActive ({ commit, dispatch, state }, {id}) {
        commit('SET_ACTIVE', {id})
    },
    fetchNearest ({ commit, dispatch }, {position, google}) {
        StoreService.getStores() // call getStore() in StoreService
            .then(response => {
                //  console.log(response.data);
                let stores = response.data.data ? response.data.data : response.data
                commit('PUSH_WITH_DISTANCE', {stores, google, position}) // commit mutation, with payload
                commit('SORT_BY_DISTANCE')
            }).finally(() => {

            })
            .catch(error => {
                const notification = {
                    type: 'error',
                    message: Drupal.t('Error getting naerst stores.'),
                    sending: {
                        type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                        source: '/stores-json',
                        referer: window.location.href,
                        error: error.message,
                    }
                }
                dispatch('notification/add', notification,
                    {
                        root: true
                    }
                )
                dispatch('errorLoading', null,
                    {
                        root: true
                    }
                )
            })
    }
}

export const getters = {
    storesVisibleCount: state => {
        return state.markers.filter(marker => marker.visible && marker.status === '1').length
    },
    convertedRadius: radius => {
        return Number(radius) * 1000
    },
    nearDistance: state => {
        return state.markers.length > 0 && state.markers[0].distance.value !== 0 ? (state.markers[0].distance.value / 1000).toFixed(2) : 0
    }
}
